import { render, staticRenderFns } from "./DescuentosLista.vue?vue&type=template&id=349555da"
import script from "./DescuentosLista.vue?vue&type=script&lang=js"
export * from "./DescuentosLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports